import { render } from "./RemoteSearch.vue?vue&type=template&id=63ec229a"
import script from "./RemoteSearch.vue?vue&type=script&lang=js"
export * from "./RemoteSearch.vue?vue&type=script&lang=js"
script.render = render

export default script